 


import React, { useState } from 'react';
import "./VendorEmployeeRequest.module.css"

const vendors = [
  { id: 'V001', name: 'Acme Corp' },
  { id: 'V002', name: 'GlobalTech' },
  { id: 'V003', name: 'InnoSystems' },
];

const VendorEmployeeRequest=()=> {
  const [formData, setFormData] = useState({
    vendorName: '',
    vendorId: '',
    numberOfEmployees: '',
    employeeNames: [''],
    remarks: '',
    photos: [],
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'file' ? e.target.files : value
    }));
  };

  const handleEmployeeNameChange = (index, value) => {
    const newEmployeeNames = [...formData.employeeNames];
    newEmployeeNames[index] = value;
    setFormData(prevData => ({
      ...prevData,
      employeeNames: newEmployeeNames
    }));
  };

  const addEmployeeName = () => {
    setFormData(prevData => ({
      ...prevData,
      employeeNames: [...prevData.employeeNames, '']
    }));
  };

  const addPhoto = () => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      if (file) {
        setFormData(prevData => ({
          ...prevData,
          photos: [...prevData.photos, file]
        }));
      }
    };
    fileInput.click();
  };

  const removePhoto = (index) => {
    setFormData(prevData => ({
      ...prevData,
      photos: prevData.photos.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.vendorName) {
      newErrors.vendorName = 'Vendor name is required';
    }
    if (!formData.vendorId) {
      newErrors.vendorId = 'Vendor ID is required';
    }
    if (!formData.numberOfEmployees) {
      newErrors.numberOfEmployees = 'Number of employees is required';
    } else if (isNaN(formData.numberOfEmployees) || formData.numberOfEmployees <= 0) {
      newErrors.numberOfEmployees = 'Please enter a valid number';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log('Form submitted:', formData);
      // Here you would typically send the data to a server
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="vendorName">Vendor Name: *</label>
          <select
            id="vendorName"
            name="vendorName"
            value={formData.vendorName}
            onChange={handleInputChange}
            className={errors.vendorName ? 'error' : ''}
            required
          >
            <option value="">Select a vendor</option>
            {vendors.map(vendor => (
              <option key={vendor.id} value={vendor.name}>{vendor.name}</option>
            ))}
          </select>
          {errors.vendorName && <span className="error-message">{errors.vendorName}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="vendorId">Vendor ID: *</label>
          <select
            id="vendorId"
            name="vendorId"
            value={formData.vendorId}
            onChange={handleInputChange}
            className={errors.vendorId ? 'error' : ''}
            required
          >
            <option value="">Select an ID</option>
            {vendors.map(vendor => (
              <option key={vendor.id} value={vendor.id}>{vendor.id}</option>
            ))}
          </select>
          {errors.vendorId && <span className="error-message">{errors.vendorId}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="numberOfEmployees">Number of Employees: *</label>
          <input
            type="number"
            id="numberOfEmployees"
            name="numberOfEmployees"
            value={formData.numberOfEmployees}
            onChange={handleInputChange}
            className={errors.numberOfEmployees ? 'error' : ''}
            required
          />
          {errors.numberOfEmployees && <span className="error-message">{errors.numberOfEmployees}</span>}
        </div>

        <div className="form-group">
          <label>Employee Names (Optional):</label>
          {formData.employeeNames.map((name, index) => (
            <input
              key={index}
              type="text"
              value={name}
              onChange={(e) => handleEmployeeNameChange(index, e.target.value)}
              placeholder={`Employee ${index + 1}`}
            />
          ))}
          <button type="button" onClick={addEmployeeName} className="add-button">Add Employee Name</button>
        </div>

        <div className="form-group">
          <label htmlFor="remarks">Remarks (Optional):</label>
          <textarea
            id="remarks"
            name="remarks"
            value={formData.remarks}
            onChange={handleInputChange}
          ></textarea>
        </div>

        <div className="form-group">
          <label>Photos (Optional):</label>
          <div className="photo-container">
            {formData.photos.map((photo, index) => (
              <div key={index} className="photo-item">
                <img src={URL.createObjectURL(photo)} alt={`Employee ${index + 1}`} />
                <button type="button" onClick={() => removePhoto(index)} className="remove-button">Remove</button>
              </div>
            ))}
          </div>
          <button type="button" onClick={addPhoto} className="add-button">Add Photo</button>
        </div>

        <button type="submit" className="submit-button">Submit</button>
      </form>
    </div>
  );
}


export default VendorEmployeeRequest